// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { Route, Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Navbar } from 'app/components/Navbar/Loadable';
import { Jelly } from '@uiball/loaders';
import { AnimatePresence } from "framer-motion";
import {Api} from '../../store/api';

export const SellerAuthenticatedRoute = ({ component: C, ...props }) => {
  // const [user, loading, error] = useAuthState(auth);
  const [session, setSession] = useState(null);
  const [authenticating, setAuthenticating] = useState(true);
  const [userProfile, setUserProfile] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const isSeller = userProfile?.is_approved_as_seller || false;

  // TODO make reusable auth hook?

  if (authenticating) return (
    <div style={{ height: '100vh', width: '100vw', display: 'flex' }}>
      <div style={{ margin: 'auto' }}>
      <Jelly size={120} speed={3} color="#ff74e9" />
      </div>
    </div>
  );


  // console.log(`AuthenticatedRoute: ${user}`)
  return (
    <React.Fragment>
      {location.pathname !== '/' && (
        <Navbar userProfile={userProfile}/>
      )}
      <AnimatePresence>
        {!authenticating && session && isSeller ? <Outlet context={[userProfile]}/> : <Navigate to="/login" />}
      </AnimatePresence>
    </React.Fragment>
  )
}